module.exports = __webpack_public_path__ + "static/bruhshijian-e6d03777abf3d0d8c67a94f84f09ee3e.mp3";